import Vue from 'vue';
import { getThClasses, getThStyles } from '../utils/gettersOfCalculatedStylesAndClasses';
import { get } from 'lodash';
import callRefFunc from 'src/utils/callRefFunc';
import { invokeOrFalse, invokeOrIdentity } from 'src/utils';
// import Tooltip from './components/Tooltip.vue'
import Tooltip from 'src/components/Tooltips/Tooltip.vue';
import open_DateRangeInput_inDialog from 'src/components/Dates/open_DateRangeInput_inDialog';
import Button from 'src/components/Button/Button';
export default Vue.extend({
    name: 'GenericTableHeaderSlot',
    components: { Tooltip, Button },
    props: {
        props: { type: Object, required: true },
        columnBeforeWhichDraggedColumnWouldBePlaced: { type: Object },
        columnBeingDragged: { type: Object },
        localFilterModel: { type: Object, default: () => ({}) },
        localSortingModel: { type: Array },
        getHtmlDescriptionOfFilterField: { type: Function },
        selectedIds: { type: Array },
        getColLabel: { type: Function },
        getAvailableLocalFilterTypes: { type: Function },
        selectedValuesFilterManualIndex: { type: Number },
        filterValueSearchTerm: { type: Object },
        paginationObject: { type: Object },
        forceSelectedValuesFilterSearchBoxToShow: { type: Boolean },
        ctx: { type: Object },
        shiftDateFilterAbstract: { type: Function },
        setColumnDisplayTimeZone: { type: Function },
        getCellPropsObject: { type: Function },
        toggleSelectionOfAllVisibleRows: { type: Function },
        addToLocalSortingModel: { type: Function },
        resetColFilter: { type: Function },
        handleFilterTypingInput: { type: Function },
        handleBlurOnFilterTextInput: { type: Function },
        addToLocalFilterModel: { type: Function },
        handleSelectAllOnFilter: { type: Function },
        allFilterValuesInColumnAreSelected: { type: Function },
        handleMovementInSelectedValuesFilter: { type: Function },
        handleEnterPressOnFilterValueSearchInput: { type: Function },
        updateLocalSetFilter: { type: Function },
        selectOnlyThisFilterItem: { type: Function },
        removeSelectedValuesFilterFromColumn: { type: Function },
        setColumnVisibility: { type: Function },
        resetColumnVisibilityAndOrderToDefaults: { type: Function },
        borderLeftIfNeededWhileMovingAnotherColumn: { type: Function },
        filterForSearchTerm: { type: Function },
        columnVisibilityAndOrOrderAreDifferentFromDefault: { type: Boolean }
    },
    computed: {
        defaultTimeZones() {
            return [
                { name: 'UTC', label: 'UTC' },
                { name: undefined, label: 'Browser\'s local time zone' }
            ];
        }
    },
    methods: {
        invokeOrIdentity,
        getThClasses,
        getThStyles,
        get,
        open_DateRangeInput_inDialog(col, filterPredicate, value) {
            open_DateRangeInput_inDialog({
                dateRangeInput_props: {
                    intervalObject: { from: value.start, to: value.end }
                }
            });
        },
        removeSelectedValuesFilterFromColumn_and_addToLocalFilterModel(col, filterPredicate, value) {
            this.removeSelectedValuesFilterFromColumn(col);
            this.addToLocalFilterModel(col, filterPredicate, value, []);
        },
        thStyles(col) {
            let res = getThStyles(col);
            res = Object.assign(Object.assign({}, res), { position: 'relative' });
            if (this.columnBeingDragged)
                res = Object.assign(Object.assign({}, res), { cursor: 'move' });
            const a = this.borderLeftIfNeededWhileMovingAnotherColumn(col);
            if (a)
                res = Object.assign(Object.assign({}, res), a);
            return res;
        },
        colSortingMode(col) {
            var _a;
            if (!this.localSortingModel || !Array.isArray(this.localSortingModel))
                return '';
            return ((_a = this.localSortingModel.find(sm => sm.field === col.field)) === null || _a === void 0 ? void 0 : _a.direction) || '';
        },
        handleEnterKeyDownOnFilterTextInput(e, col, filterItem) {
            e.target.blur();
            // @ts-ignore
            const cRef = this.$refs[`cell-context-menu-${col.name}`];
            invokeOrFalse(cRef === null || cRef === void 0 ? void 0 : cRef[0].hide);
            this.handleBlurOnFilterTextInput(col, filterItem);
        },
        checkboxOfFilterValueIsChecked(localFilterModel, col, aItem) {
            if (localFilterModel[col.name] && localFilterModel[col.name].containedIn) {
                if (col.isArray) {
                    return aItem.values.some((val) => localFilterModel[col.name].containedIn.includes(val));
                }
                else {
                    return localFilterModel[col.name].containedIn.map((s) => String(s)).some((r) => aItem.values.map((a) => String(a)).includes(r));
                }
            }
            return true;
        },
        focusRef(ref) {
            setTimeout(() => {
                callRefFunc(this, ref, 'focus');
            }, 100);
        },
        colHasFilter(col, filterPredicate) {
            var _a;
            // @ts-ignore
            const filters = (_a = this.localFilterModel) === null || _a === void 0 ? void 0 : _a[col.name];
            if (!filters || !filters[filterPredicate])
                return false;
            if (filters[filterPredicate].length > 0)
                return true;
            return false;
        },
        getHeaderInfoTip(col) {
            if (!col.headerInfoTip)
                return undefined;
            if (typeof col.headerInfoTip === 'function')
                return col.headerInfoTip(this);
            if (typeof col.headerInfoTip === 'string')
                return col.headerInfoTip;
            return undefined;
        },
        getTimeZoneOptions(col) {
            let res = this.defaultTimeZones;
            if (Array.isArray(col.timeZoneOptions))
                res = [...res, ...col.timeZoneOptions];
            return res;
        },
        colHasSorting(col) { return Boolean(this.localSortingModel && Array.isArray(this.localSortingModel) && this.localSortingModel.some(sm => sm.field === col.field)); },
        iAmBeingDraggedClasses(col) {
            if (!col || !this.columnBeingDragged)
                return '';
            return this.columnBeingDragged.name === col.name
                ? 'animated headShake animation-duration-2000 animation-iteration-infinite'
                : '';
        },
        colHasFilters(col) {
            var _a;
            // @ts-ignore
            const filters = (_a = this.localFilterModel) === null || _a === void 0 ? void 0 : _a[col.name];
            if (!filters)
                return false;
            const predicates = Object.keys(filters);
            return predicates.length > 0;
        }
    }
});
